import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  constructor(private router: Router, private http: HttpClient) { }

  private headers = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
    Accept: '*/*'
  });
  

  GetCompanyByID(): Observable<any> {
    const body = new HttpParams({});
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Company/GetCompanyByID`, body, options);
  }

  GetStates(): Observable<any> {
    const body = new HttpParams({});
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Company/GetStatesForNewCompany`, body, options);
  }

  GetAllCompanies(data): Observable<any> {
    const body = new HttpParams({fromObject:data});
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Company/GetAllCompanies`, body, options);
  }

  GetCompanyByCompanyID(): Observable<any> {
    const body = new HttpParams({});
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Company/GetCompanyByCompanyID`, body, options);
  }

  InsertCompany(data): Observable<any> {
    const body = new HttpParams({fromObject:data});
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Company/InsertCompany`, body, options);
  }

  UpdateCompany(data): Observable<any> {
    const body = new HttpParams({fromObject:data});
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Company/UpdateCompany`, body, options);
  }

  ResetPasswordForCompany(data): Observable<any> {
    const body = new HttpParams({fromObject:data});
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Company/ResetPasswordForCompany`, body, options);
  }

  DeleteCompany(data): Observable<any> {
    const body = new HttpParams({fromObject:data});
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Company/DeleteCompany`, body, options);
  }

  DeleteCompanyByFY(data): Observable<any> {
    const body = new HttpParams({fromObject:data});
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}Company/DeleteCompanyByFY`, body, options);
  }

  getFinancialYearFromDate(financialYear: string): string {
    return financialYear?.trim() || '';
  }

  getFinancialYearToDate(financialYear: string): string {
    const fromDate = this.getFinancialYearFromDate(financialYear);
    if (!fromDate) {
      return '';
    }

    const parts = fromDate.split(/[\/\-\.]/);
    if (parts.length !== 3) {
      return fromDate;
    }

    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
    if (isNaN(day) || isNaN(month) || isNaN(year)) {
      return fromDate;
    }

    const endDate = new Date(year + 1, month - 1, day);
    endDate.setDate(endDate.getDate() - 1);

    const dd = String(endDate.getDate()).padStart(2, '0');
    const mm = String(endDate.getMonth() + 1).padStart(2, '0');
    const yyyy = endDate.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }
}
